'use strict';

module.exports = require('./timers').setTimeout;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/set-timeout.js
 ** module id = 718
 ** module chunks = 0 1
 **/